import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import EcoMode from '../lib/EcoMode';

import { USER_PREFERENCES_UPDATED } from '../lib/events';
import { loadGsapFull } from '../lib/async-bundles';

export default (el, props) => {
    const $el = $(el);
    const { hasDrag } = props;
    const $dragInner = $el.find('[data-drag-inner]');

    let gsap = null;
    let Draggable = null;
    let InertiaPlugin = null;
    let ScrollToPlugin = null;
    let dragger = null;

    let scrollTargets = [];
    let lastActiveOffset = 0;

    const init = () => {
        if (EcoMode.shouldAnimate()) {
            loadBundles();
        }

        initScrollTargets();
        initScrollLinks();

        Viewport.on('resize', onResize);
        Viewport.on('scroll', onScroll);
        Dispatch.on(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };

    const destroy = () => {
        destroyDragger();
        $el.off('click');
        Viewport.off('resize', updateDragger);
        Viewport.off('scroll', onScroll);
        Dispatch.off(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };
    
    const onUserPreferencesUpdated = () => {
        if (EcoMode.shouldAnimate()) {
            if (gsap === null) {
                loadBundles();
            }
        } else {
            if (gsap !== null) {
                destroyDragger();
            }
            
            gsap = null;
            Draggable = null;
            InertiaPlugin = null;
            ScrollToPlugin = null;
        }
    };

    const onResize = () => {

    };

    const onScroll = () => {
        let currentTarget = null;
        
        scrollTargets.forEach(target => {
            if (target.activePos <= Viewport.scrollTop + 30) {
                currentTarget = target;
            }
        });
        
        if (currentTarget) {
            if (currentTarget.activePos !== lastActiveOffset) {
                $el.find('a').removeClass('active');
                currentTarget.$link.addClass('active');
                lastActiveOffset = currentTarget.activePos;
            }
        } else {
            $el.find('a').removeClass('active');
            lastActiveOffset = 0;
        }
    };
    
    const loadBundles = () => {
        if (gsap === null) {
            loadGsapFull(({ default: loadedData }) => {
                gsap = loadedData.gsap;
                Draggable = loadedData.Draggable;
                InertiaPlugin = loadedData.InertiaPlugin;
                ScrollToPlugin = loadedData.ScrollToPlugin;

                gsap.registerPlugin(InertiaPlugin, ScrollToPlugin);

                // gsap.defaults({ overwrite: 'auto' });

                initDraggable();
                Viewport.on('resize', updateDragger);
            });
        }
    };    

    const initDraggable = () => {
        if (hasDrag) {
            $el.css({ overflow: 'hidden' });
            $dragInner.addClass('whitespace-nowrap inline-block').removeClass('flex flex-nowrap');

            dragger = Draggable.create($dragInner.get(0), {
                type: 'x',
                inertia: true,
                resistance: 0.75,
                edgeResistance: 0.95,
                maxDuration: 0.4,
                bounds: {
                    minX: 0,
                    maxX: 0
                }
            })[0];

            updateDragger();
        }
    };

    const updateDragger = () => {
        if (dragger !== null) {
            const diff = $dragInner.width() - $el.width();

            dragger.applyBounds({
                minX: Math.min(-diff, 0),
                maxX: 0
            });

            dragger.update(true);
        }
    };

    const destroyDragger = () => {
        if (dragger !== null) {
            dragger.kill();
            dragger = null;
            
            $el.css({ overflow: '' });
            $dragInner.removeClass('whitespace-nowrap inline-block').addClass('flex flex-nowrap');
        }
        Viewport.off('resize', updateDragger);
    };

    const initScrollTargets = () => {
        scrollTargets = [];
        const $links = $el.find('a');

        $links.each(item => {
            const $link = $(item);
            const href = $link.attr('href');
            const $target = $(href);

            if ($target.length > 0) {
                const targetPos = $target.offset().top;
                
                let scrollMargin;

                try {
                    scrollMargin = parseInt(window.getComputedStyle($target.get(0)).getPropertyValue('scroll-margin-top') || 0, 10);
                } catch (error) {
                    scrollMargin = 0;
                }

                scrollTargets.push({
                    $link,
                    activePos: targetPos - scrollMargin
                });
            }
        });
    };

    const initScrollLinks = () => {
        $el.on('click', 'a', e => {
            if (EcoMode.shouldAnimate()) {
                e.preventDefault();

                const $link = $(e.triggerTarget);
                const href = $link.attr('href');
                const $target = $(href);

                if ($target.length > 0) {
                    const targetPos = $target.offset().top;
                    let scrollMargin;

                    try {
                        scrollMargin = parseInt(window.getComputedStyle($target.get(0)).getPropertyValue('scroll-margin-top') || 0, 10);
                    } catch (error) {
                        scrollMargin = 0;
                    }

                    gsap.to(window, {
                        scrollTo: {
                            y: targetPos,
                            offsetY: scrollMargin,
                            autoKill: false
                        },
                        duration: 0.6,
                        ease: 'power2.inOut'
                    });
                }
            }
        });
    };

    return {
        init,
        destroy
    };
};
